import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import * as apps from '../../enums/apps';

const apiNameConversion = {
    [apps.APP_NAME_INBOX]: 'preview_conversations',
    [apps.APP_NAME_NOTIFICATIONS]: 'preview_pinned_flashes',
};

export const fetchDrawerData = ({ timestamp = 0, source = apps.APP_NAME_NOTIFICATIONS } = {}) => {
    const url = pathfinder(apiNameConversion[source], {
        timestamp: timestamp.toString(),
    });

    return axios
        .get(url)
        .then((res) => res.data)
        .catch(() => ({}));
};
